import React from 'react';
import IconButton, { IconButtonProps } from './IconButton';

type MapButtonProps = {
    ['data-testid']: string;
} & IconButtonProps;

const MapButton = ({ color, 'data-testid': dataTestId, sx, ...otherProps }: MapButtonProps) => {
    return (
        <IconButton
            color={color}
            sx={[
                (theme) => theme.mixins.mapButton,
                {
                    '&.Mui-disabled': {
                        color: (theme) => theme.palette.action.disabled,
                        backgroundColor: (theme) => theme.palette.disabledGray.dark
                    }
                },
                ...(Array.isArray(sx) ? sx : [sx])
            ]}
            {...otherProps}
            data-testid={dataTestId}
            disabled={otherProps.disabled}
        ></IconButton>
    );
};

export default MapButton;
